import "../assets/css/services.css";
import { Link } from 'react-router-dom';
import '../assets/css/Footer.css';
import useEmailSender from '../components/hooks/useEmailSender';
import Contact from "../forms/contact";
import Hero from '../components/services/Hero';
import { Helmet } from "react-helmet-async";


export default function HeroServices() {
  const { sendEmails } = useEmailSender();
  async function onSubmitFormRequest(formData,INFOTYPE) {
    return await sendEmails(formData,INFOTYPE);
  }
  return (
    <>

<Helmet>
        <title>
          Website Maintenance & Support Services | Apurva Software Solutions
        </title>

        <meta
          name="description"
          content="Reliable website maintenance services including updates, security, backups, and performance optimization to keep your website running smoothly."
        />

        <meta
          name="keywords"
          content="website maintenance services, website support services, website security services, website bug fixing services, website updates services, website performance optimization, website maintenance company India, affordable website maintenance services, hire website maintenance experts, professional website support company, website security and malware removal services, website bug fixing and troubleshooting services, website speed optimization services, website maintenance for small businesses, ecommerce website maintenance services, WordPress website maintenance services, website maintenance and support packages, 24/7 website support services, website uptime monitoring services, website backup and recovery services, website maintenance company for startups, custom website maintenance services India, secure website maintenance services, website performance tuning services, website error fixing services, website redesign and maintenance services, website maintenance services for ecommerce websites, website technical support services India, website maintenance agency India, website maintenance with SEO optimization, monthly website maintenance services, website maintenance services with security updates, website maintenance services with fast support, website support and troubleshooting services, website maintenance for business websites, website maintenance for corporate websites, website speed and performance optimization services, website maintenance company with affordable pricing, website maintenance and bug fixing company, website maintenance services for dynamic websites, website maintenance services for static websites, website maintenance and hosting support services, website maintenance services for WordPress sites, website maintenance and monitoring services, website maintenance company with 24/7 support, website maintenance services with backup solutions, website maintenance services for secure websites, website maintenance services for high traffic websites, website maintenance services with regular updates, best website maintenance company for long term support"
        />

        <meta name="robots" content="index, follow" />

        <link
          rel="canonical"
          href="https://apurvasoftwaresolutions.com/maintenance-support"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Website Maintenance & Support Services"
        />
        <meta
          property="og:description"
          content="Keep your website secure, fast, and updated with our expert maintenance services."
        />
        <meta
          property="og:url"
          content="https://apurvasoftwaresolutions.com/maintenance-support"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://apurvasoftwaresolutions.com/apurvasoftwaresolutions.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Website Maintenance Services"
        />
        <meta
          name="twitter:description"
          content="Professional website maintenance, updates, and security services."
        />
        <meta
          name="twitter:image"
          content="https://apurvasoftwaresolutions.com/apurvasoftwaresolutions.png"
        />

        {/* Extra */}
  <meta name="author" content="Apurva Software Solutions" />
  <meta name="language" content="English" />
  <meta name="revisit-after" content="7 days" />

  {/* Favicon */}
  <link rel="icon" href="/favicon.ico" />
      </Helmet>

        <div className="relative w-full">
        <img src="/img/apurvasoftwaresolutions-maintenance-service.png"
        className="w-full"/>


                {/* Overlay (optional for better text visibility) */}
                <div className="absolute inset-0 bg-black/20"></div>
  
  {/* Left Side Content */}
  <div className="absolute  hidden lg:block top-1/2 left-10 transform -translate-y-1/2 max-w-lg text-left">
  
  <h1 className="text-3xl font-bold text-white leading-tight">
  Reliable 
  <span className="text-[#ff4a17]"> Website Maintenance & Support</span> <br />
  To Keep Your Business Running Smoothly
</h1>

<p className="mt-4 text-white/90 text-sm leading-relaxed">
  Apurva Software Solutions provides comprehensive website maintenance and 
  support services to ensure your digital presence stays secure, updated, 
  and high-performing at all times. From regular updates and bug fixes to 
  performance optimization and security monitoring, we handle everything 
  so you can focus on growing your business. Our proactive approach includes 
  backups, uptime monitoring, and continuous improvements to keep your website 
  fast, reliable, and ready for future growth.
</p>

  {/* Button */}
  <button 
    className="mt-6 px-6 py-3 bg-[#ff4a17] text-white rounded-lg shadow-lg hover:bg-orange-600 transition"
    onClick={() => {
      document
        .getElementById("contact")
        .scrollIntoView({ behavior: "smooth" });
    }}
  >
    Start Your Project
  </button>
</div>

        </div>
   

<section class="maintenance-process w-full max-w-none px-6 ">
  <div class="text-center">
  <h2 className="text-3xl font-bold">
        Website Development &{" "}
          <span className="bg-[#ff4a17] bg-clip-text text-transparent">
          Maintenance Process
          </span>
      </h2>
        <div className="w-20 h-[2px] bg-[#ff4a17] mx-auto mt-4"></div>
        <p class="section-subtitle">
      Having decades of experience, we have developed processes and systems
      from onboarding to satisfaction.
    </p>
  
    <div class="row mt-5">

      <div class="col-md-3 col-sm-6 mb-4">
        <span class="step-label">Step 01</span>
        <div class="step-icon yellow">
          <i class="bi bi-lightbulb"></i>
        </div>
        <h5>Get a Quote</h5>
        <p class="step-subtitle">Detailed Scope</p>
        <p class="step-desc">
          Get an instant detailed scope of work quote.
        </p>
      </div>

    
      <div class="col-md-3 col-sm-6 mb-4">
        <span class="step-label">Step 02</span>
        <div class="step-icon blue">
          <i class="bi bi-pencil-square"></i>
        </div>
        <h5>Pick a Plan</h5>
        <p class="step-subtitle">Tailored Made For You</p>
        <p class="step-desc">
          Choose the right plan suitable for your website.
        </p>
      </div>

     
      <div class="col-md-3 col-sm-6 mb-4">
        <span class="step-label">Step 03</span>
        <div class="step-icon purple">
          <i class="bi-person-check"></i>
        </div>
        <h5>Onboard</h5>
        <p class="step-subtitle">To the Program</p>
        <p class="step-desc">
          Intense onboarding optimization to improve performance.
        </p>
      </div>

      
      <div class="col-md-3 col-sm-6 mb-4">
        <span class="step-label">Step 04</span>
        <div class="step-icon orange">
          <i class="bi bi-headset"></i>
        </div>
        <h5>Get Support</h5>
        <p class="step-subtitle">Ongoing & Unparalleled Support</p>
        <p class="step-desc">
          Be relaxed now! You are backed by the most advanced technical team.
        </p>
      </div>

    </div>
  </div>
</section>

<section class="faq-section py-5">
  <div class="w-full p-6">
    <div class="text-center">
  <h2 className="text-3xl font-bold">
        Frequently{" "}
          <span className="bg-[#ff4a17] bg-clip-text text-transparent">
          Asked Question
          </span>
      </h2>
      <div className="w-20 h-[2px] bg-[#ff4a17] mx-auto mt-4"></div>
      </div>

    <div class="accordion faq-accordion" id="faqAccordion">

      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq1">
            As a known software development company, what services do you offer?
          </button>
        </h2>
        <div id="faq1" class="accordion-collapse collapse text-black" data-bs-parent="#faqAccordion">
          <div class="accordion-body">
            We offer custom software development, web & mobile apps, UI/UX design,
            cloud solutions, cybersecurity, SEO, and maintenance services.
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq2">
            Does your company work with all types of technology and platforms?
          </button>
        </h2>
        <div id="faq2" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
          <div class="accordion-body">
            Yes, we work with MERN, MEAN, React, Angular, Node.js, cloud platforms,
            and custom enterprise solutions.
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq3">
            Do you provide after-development services?
          </button>
        </h2>
        <div id="faq3" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
          <div class="accordion-body">
            Absolutely. We provide maintenance, monitoring, security updates,
            performance optimization, and support plans.
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq4">
            Does your company work in a zero time zone?
          </button>
        </h2>
        <div id="faq4" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
          <div class="accordion-body">
            Yes, we provide flexible working hours and support clients globally
            across time zones.
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq5">
            How much time will it take to develop the software?
          </button>
        </h2>
        <div id="faq5" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
          <div class="accordion-body">
            Timelines depend on project scope, complexity, and integrations.
            We provide a clear milestone-based plan before starting.
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<Contact/>


</>
  );
}

function ImageBox({ color, img }) {
  return (
    <div className={`img-box ${color}`}>
      <img src={img} alt="Team Member" />
    </div>
  );
}
